export function fireNumber(spending, withdrawal, tax = 0) {
  if (withdrawal <= 0 || tax >= 1) return 0
  return spending / (1 - tax) / withdrawal
}

export function realReturn({ nominal, inflation = 0, fees = 0 }) {
  return (1 + nominal - fees) / (1 + inflation) - 1
}

export function monthlyRate(annual) {
  return Math.pow(1 + annual, 1 / 12) - 1
}

export function project({ portfolio, monthly, annual, raise = 0, months }) {
  const rate = monthlyRate(annual)
  const points = [{ month: 0, value: portfolio, invested: portfolio, saving: monthly }]
  let value = portfolio
  let invested = portfolio
  let saving = monthly

  for (let month = 1; month <= months; month++) {
    if (month > 1 && (month - 1) % 12 === 0) saving *= 1 + raise
    value = value * (1 + rate) + saving
    invested += saving
    points.push({ month, value, invested, saving })
  }

  return points
}

export function monthsToTarget({ target, limit = 1200, ...plan }) {
  const month = project({ ...plan, months: limit }).findIndex((point) => point.value >= target)
  return month === -1 ? null : month
}

export function coastNumber(target, annual, months) {
  return target / Math.pow(1 + monthlyRate(annual), months)
}

export function monthsToCoast({ target, months, ...plan }) {
  const month = project({ ...plan, months }).findIndex((point) => point.value >= coastNumber(target, plan.annual, months - point.month))
  return month === -1 ? null : month
}
